import {
  actions,
  getQuizzesAsDataTableAsync,
  createNewQuizAsync,
  editQuizAsync,
  // changeQuizPublishStateAsync,
} from './slices';

export const QuizzesActions = {
  ...actions,
  getQuizzesAsDataTableAsync,
  createNewQuizAsync,
  editQuizAsync,
  // changeQuizPublishStateAsync,
};
